import { MetricService } from "app/services/metric/MetricService";
import { MetricUtil } from "app/services/metric/MetricUtil";
import React, { useEffect, useState } from "react";
import { Metric, ReachMetric } from "../../../components/metrics/ReachMetric";
import { useDataReport } from "../../../DataReportProvider";
import { metrics } from "app/utils/data/metrics";
import { updateLoadedMetrics } from "app/store/reducers/metric_reducer";
import { useDispatch } from "react-redux";
import { getLoadedMetricById } from "app/utils/utils";

const EngagementElearning: React.FC = () => {

    // const [usersRegistered, setUsersRegistered] = useState<Metric[] | null>(null)
    const [totalEnrolments, setTotalEnrolments] = useState<Metric[] | null>(null)
    const [totalIssuedCertificates, setTotalIssuedCertificates] = useState<Metric[] | null>(null)
    const [completedCourses, setCompletedCourses] = useState<Metric[] | null>(null)

    const dataReport = useDataReport()
    const dispatch = useDispatch();

    /*
    const getUsersRegistered = async (modifiedParams: any) => {
        let response = (await (new MetricService()).getMetricData(modifiedParams, metrics.usersRegistered.endpoint)).getResponseData();
        if (response.success === true) {
            setUsersRegistered(response.data);
            dispatch(updateLoadedMetrics({id: metrics.usersRegistered.id, data: response.data}));
        }
    }
    */

    const getTotalEnrolments = async (modifiedParams: any) => {
        let response = (await (new MetricService()).getMetricData(modifiedParams, metrics.totalEnrolments.endpoint)).getResponseData();
        if (response.success === true) {
            setTotalEnrolments(response.data);
            dispatch(updateLoadedMetrics({id: metrics.totalEnrolments.id, data: response.data}));
        }
    }

    const getTotalIssuedCertificates = async (modifiedParams: any) => {
        let response = (await (new MetricService()).getMetricData(modifiedParams, metrics.totalIssuedCertificates.endpoint)).getResponseData();
        if (response.success === true) {
            setTotalIssuedCertificates(response.data);
            dispatch(updateLoadedMetrics({id: metrics.totalIssuedCertificates.id, data: response.data}));
        }
    }

    const getCompletedCourses = async (modifiedParams: any) => {
        let response = (await (new MetricService()).getMetricData(modifiedParams, metrics.eLearningCoursesCompleted.endpoint)).getResponseData();
        if (response.success === true) {
            setCompletedCourses(response.data);
            dispatch(updateLoadedMetrics({id: metrics.eLearningCoursesCompleted.id, data: response.data}));
        }
    }


    /** 
     * To calculate amount and percent of latest "n" periods, we need to modify date filtered before 
     * make request. We need to do that because the widget needs to retrive last 24
     * times periods before the requested date to calculate the amount 
    */
    const getMetrics = () => {

        const calculateStartDate = MetricUtil.calculateStartDate(dataReport.params.filter_filters.between_dates.from, dataReport.params.filter_filters.mode);

        const modifiedParams = {
            ...dataReport.params,
            filter_filters: {
                ...dataReport.params.filter_filters,
                between_dates: {
                    from: calculateStartDate,
                    to: dataReport.params.filter_filters.between_dates.to
                }
            }
        };

        //let users_registered = getLoadedMetricById(metrics.usersRegistered.id);
        let total_enrolments = getLoadedMetricById(metrics.totalEnrolments.id);
        let total_issued_certificates = getLoadedMetricById(metrics.totalIssuedCertificates.id);
        let completed_courses = getLoadedMetricById(metrics.eLearningCoursesCompleted.id);

        /*
        if(users_registered !== null && users_registered !== undefined) {
            setUsersRegistered(users_registered);
        }else{
            getUsersRegistered(modifiedParams);
        }
        */

        if(total_enrolments !== null && total_enrolments !== undefined) {
            setTotalEnrolments(total_enrolments);
        }else{
            getTotalEnrolments(modifiedParams);
        }

        if(total_issued_certificates !== null && total_issued_certificates !== undefined) {
            setTotalIssuedCertificates(total_issued_certificates);
        }else{
            getTotalIssuedCertificates(modifiedParams);
        }

        if(completed_courses !== null && completed_courses !== undefined) {
            setCompletedCourses(completed_courses);
        }else{
            getCompletedCourses(modifiedParams);
        }

    }

    const resetReports = () => {
        //setUsersRegistered(null);
        setTotalEnrolments(null);
        setTotalIssuedCertificates(null);
        setCompletedCourses(null);

    }


    useEffect(() => {
        resetReports();
        getMetrics();
    }, [dataReport.params])


    return (
        <>
            <div className='row g-5 g-xl-8' style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                <div className="col-xl-12">
                    <hr></hr>
                </div>
                {/* begin::Col */}
                {/*
                <div className='col-xl-6 flex-xl-fill mt-0'>
                    <ReachMetric
                        logo_image={'/media/svg/metric_icons/'+metrics.usersRegistered.logo}
                        snapshotId={metrics.usersRegistered.id}
                        title={metrics.usersRegistered.title}
                        subtitle={metrics.usersRegistered.subtitle}
                        startPeriod={24}
                        metrics={usersRegistered}
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='250px'
                        snapshotSwitch={true}
                    />
                </div>
                */}
                {/* end::Col */}
                {/* begin::Col */}
                <div className='col-xl-6 flex-xl-fill mt-0'>
                    <ReachMetric
                        logo_image={'/media/svg/metric_icons/'+metrics.totalEnrolments.logo}
                        snapshotId={metrics.totalEnrolments.id}
                        title={metrics.totalEnrolments.title}
                        subtitle={metrics.totalEnrolments.subtitle}
                        startPeriod={24}
                        metrics={totalEnrolments}
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='250px'
                        snapshotSwitch={true}
                    />
                </div>
                {/* end::Col */}
                {/* begin::Col */}
                <div className='col-xl-6 flex-xl-fill mt-0'>
                    <ReachMetric
                        logo_image={'/media/svg/metric_icons/'+metrics.eLearningCoursesCompleted.logo}
                        snapshotId={metrics.eLearningCoursesCompleted.id}
                        title={metrics.eLearningCoursesCompleted.title}
                        subtitle={metrics.eLearningCoursesCompleted.subtitle}
                        startPeriod={24}
                        metrics={completedCourses}
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='250px'
                        snapshotSwitch={true}
                    />
                </div>
                {/* end::Col */}
                {/* begin::Col */}
                <div className='col-xl-6 flex-xl-fill mt-0'>
                    <ReachMetric
                        logo_image={'/media/svg/metric_icons/'+metrics.totalIssuedCertificates.logo}
                        snapshotId={metrics.totalIssuedCertificates.id}
                        title={metrics.totalIssuedCertificates.title}
                        subtitle={metrics.totalIssuedCertificates.subtitle}
                        startPeriod={24}
                        metrics={totalIssuedCertificates}
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='250px'
                        snapshotSwitch={true}
                    />
                </div>
                {/* end::Col */}
            </div>

        </>
    )
}


export default EngagementElearning;